import styled, { css } from 'styled-components/macro';

export const FileUploadDiv = styled.div`
  margin: 2rem 0;
  position: relative;
`;

export const DropPanelDiv = styled.div`
  height: 11rem;
  border: 2px dashed ${props => props.theme.mercury};
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 0.8rem;
  a {
    width: 10rem;
    margin-left: 2rem;
    padding: 1rem;
  }
  &:focus {
    outline: none;
  }
  ${props =>
    props.dragActive &&
    css`
      border-color: ${props => props.theme.brand};
    `}
`;

export const UploadIconImg = styled.img`
  height: 4rem;
`;

export const UploadLabelP = styled.p`
  color: ${props => props.theme.dustyGray};
  font-style: italic;
  width: 35%;
  text-align: center;
  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const FileNameP = styled.p`
  font-style: italic;
  color: ${props => props.theme.brand};
  width: 35%;
  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const FileUploadLabel = styled.label`
  ${props =>
    props.error &&
    css`
      color: ${props => props.theme.red};
    `}
`;

export const SecondaryLabelSpan = styled.span`
  font-style: italic;
  color: ${props => props.theme.dustyGray};
`;

export const ThumbDiv = styled.div`
  display: flex;
  margin: auto;
  margin-top: 30px;
  width: 80%; /* //temp */
  justify-content: center;
`;

export const ThumbInnerDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const PreviewImg = styled.img`
  display: block;
  max-width: 150px;
`;

export const DeleteH5 = styled.h5`
  color: ${props => props.theme.dustierGray};
  text-transform: uppercase;
  margin-top: 5px;
  text-align: right;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
